export default () => {
  document.querySelectorAll(".js-email-sticky").forEach((el) => {
    const buttonEl = el.querySelector(".js-email-sticky-toggle");
    let expanded = false;
    buttonEl.setAttribute("aria-expanded", expanded);

    const toggleEmailSticky = (el) => {
      expanded = !expanded;
      // once the component is interacted with, it should stay visible
      el.classList.add("is-visible");
      el.classList.toggle("is-open");
      buttonEl.setAttribute("aria-expanded", expanded);
    };

    buttonEl.addEventListener("click", () => toggleEmailSticky(el));

    // https://stackoverflow.com/questions/2387136/cross-browser-method-to-determine-vertical-scroll-percentage-in-javascript
    const docEl = document.documentElement;
    const docBod = document.body;
    const st = "scrollTop";
    const sh = "scrollHeight";

    const scrollHandler = () => {
      let scrollPercent =
        ((docEl[st] || docBod[st]) /
          ((docEl[sh] || docBod[sh]) - docEl.clientHeight)) *
        100;
      if (scrollPercent >= (el.dataset.scrollDepth ?? 50)) {
        el.classList.add("is-visible");
        document.removeEventListener("scroll", scrollHandler);
      }
    };

    document.addEventListener("scroll", scrollHandler);
  });
};
